export class RiskManager {

    constructor() {
    }

    /**
     * @returns {string}
     */
    get policyGroup() {
        return this._policyGroup;
    }

    /**
     * @param value {string}
     */
    set policyGroup(value) {
        this._policyGroup = value;
    }

    /**
     * @returns {string}
     */
    get policy() {
        return this._policy;
    }

    /**
     * @param value {string}
     */
    set policy(value) {
        this._policy = value;
    }

    serialize() {
        return {
            policyGroup: this.policyGroup,
            policy: this.policy
        };
    }

    /**
     * @param jsonValue {json}
     */
    static fromJson(jsonValue) {
        let riskManager = new RiskManager();
        riskManager.policyGroup = jsonValue.policyGroup ? jsonValue.policyGroup : null;
        riskManager.policy = jsonValue.policy ? jsonValue.policy : null;

        return riskManager;
    }
}
